import { render, staticRenderFns } from "./ComplaintsModal.vue?vue&type=template&id=1ec654fb&scoped=true"
import script from "./ComplaintsModal.vue?vue&type=script&lang=js"
export * from "./ComplaintsModal.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsModal.vue?vue&type=style&index=0&id=1ec654fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec654fb",
  null
  
)

export default component.exports